import React, { useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import styles from './VerificationMail.module.css';

const VerificationMail = () => {
  const { clientId } = useParams();
  const [status, setStatus] = useState('pending');

  const handleVerify = async () => {
    try {
      if (!clientId) {
        setStatus('error');
        return;
      }

      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-backend.full-trucking-service.com';
      const response = await axios.post(`${apiUrl}/verify-email/${clientId}`);
      
      if (response.status === 200) {
        if (response.data.message === 'Email already verified!') {
          setStatus('already');
        } else {
          setStatus('verified');
        }
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error verifying email:', error);
      setStatus('error');
    }
  };

  return (
    <div className={styles.containerVerifyEmail}>
      <h2>Email Verification</h2>
      {!clientId && <p className={styles.errorMessageVerifyEmail}>Invalid verification link. Client ID missing.</p>}
      
      {clientId && status === 'pending' && (
        <>
          <p>Welcome to Full Trucking Service! Please click the button below to verify your email.</p>
          <button onClick={handleVerify} className={styles.verifyButtonEmail}>Verify Email</button>
        </>
      )}

      {status === 'verified' && <p className={styles.successMessageVerifyEmail}>🎉 Your email has been verified successfully!</p>}
      {status === 'already' && <p className={styles.successMessageVerifyEmail}>✅ Your email is already verified!</p>}
      {status === 'error' && <p className={styles.errorMessageVerifyEmail}>There was an error verifying your email. Please try again.</p>}
    </div>
  );
};

export default VerificationMail;
